// import React from 'react';
// import Nexora from '../../assets/nexora.png'
// function dfoot() {
//     return (
//         <footer >
//   <div class="container">
//     <div class="row g-4">
//       <div class="col-lg-5">
//         <div class="footer-logo mb-4">Nexora Systems</div>
//      <img class="w-100" style={{maxWidth:'250px'}} src={Nexora}/>
//       </div>
//       <div class="col-lg-3 offset-lg-1">
//                         <p style={{ fontSize:'.65rem', letterSpacing:'.16rem',textTransform:'uppercase',color:'white'}}>Navigation</p>
//         <ul class="footer-links flex-column gap-3" style={{paddingLeft:'0rem', color:'white'}}>
//           <li ><a class="footer-nav" href="#intro"  >Company Overview</a></li>
//           <li><a class="footer-nav" href="#reasons" >Why Invest</a></li>
//           <li><a class="footer-nav" href="#business" >Business Summary</a></li>
//           <li><a class="footer-nav" href="#market" >Market Analysis</a></li>
//           <li><a class="footer-nav" href="#terms" >Offering Terms</a></li>
//           <li><a class="footer-nav"href="#team" >Management Team</a></li>
//         </ul>
//       </div>
//       <div class="col-lg-3">
//         <p style={{fontSize:'.65rem', letterSpacing:'.16rem', textTransform:'uppercase', color:'white', marginBottom:'20px'}}>Contact</p>
//         <p style={{fontSize:'.82rem', lineHeight:'1.8'}} class="footer-contact">
//           Nexora Systems<br/>
//           1501 Broadway, Suite 1700<br/>
//           New York, NY 10036<br/><br/>
//           investor@nexorasystems.com<br/>
//           +1 (212) 534-5423 
//         </p>
//       </div>
//     </div>
//     <div class="footer-copy text-center ">
//   <p style={{color:'white'}}> Regulation D 506(c) Mandated Legend
// <br/>

// Any historical performance data represents past performance. Past performance does not guarantee future results; Current performance may be different than the performance data presented; The Company is not required by law to follow any standard methodology when calculating and representing performance data; The performance of the Company may not be directly comparable to the performance of other private or registered funds or companies; The securities are being offered in reliance on an exemption from the registration requirements, and therefore are not required to comply with certain specific disclosure requirements; The Securities and Exchange Commission has not passed upon the merits of or approved the securities, the terms of the offering, or the accuracy of the materials.</p>
//     </div>
//   </div>
// </footer>
//     )
// }

// export default dfoot

import React from 'react';
import Nexora from '../../assets/bochwhite.png';

import '../footer.css';

function Dfoot() {

  return (

    <footer className="site-footer">

      {/* Decorative background elements */}

      <div className="footer-glow footer-glow-left"></div>
      <div className="footer-glow footer-glow-right"></div>


      <div className="container position-relative">


        {/* TOP FOOTER */}

        <div className="row g-5 footer-main">


          {/* LOGO / COMPANY */}

          <div className="col-12 col-lg-5">

            <div className="footer-brand">

              {/* <div className="footer-eyebrow">
                INVESTOR PORTAL
              </div> */}

              <div className="footer-logo">
                Boch Investment Fund, LLC
              </div>

              <div className="footer-brand-line"></div>

              <img
                className="footer-image"
                src={Nexora}
                alt="Nexora Systems"
              />

            </div>

          </div>


          {/* NAVIGATION */}

          <div className="col-12 col-lg-3 offset-lg-1">

            <div className="footer-column">

              <p className="footer-heading">
                Navigation
              </p>

              <ul className="footer-links">

                <li>
                  <a
                    className="footer-nav"
                    href="#intro"
                  >
                    <span>Company Overview</span>
                    <span className="footer-arrow">→</span>
                  </a>
                </li>

                <li>
                  <a
                    className="footer-nav"
                    href="#reasons"
                  >
                    <span>Why Invest</span>
                    <span className="footer-arrow">→</span>
                  </a>
                </li>

                <li>
                  <a
                    className="footer-nav"
                    href="#business"
                  >
                    <span>Business Summary</span>
                    <span className="footer-arrow">→</span>
                  </a>
                </li>

                {/* <li>
                  <a
                    className="footer-nav"
                    href="#market"
                  >
                    <span>Market Analysis</span>
                    <span className="footer-arrow">→</span>
                  </a>
                </li> */}

                <li>
                  <a
                    className="footer-nav"
                    href="#terms"
                  >
                    <span>Offering Terms</span>
                    <span className="footer-arrow">→</span>
                  </a>
                </li>

                <li>
                  <a
                    className="footer-nav"
                    href="#team"
                  >
                    <span>Management Team</span>
                    <span className="footer-arrow">→</span>
                  </a>
                </li>

              </ul>

            </div>

          </div>


          {/* CONTACT */}

          <div className="col-12 col-lg-3">

            <div className="footer-column">

              <p className="footer-heading">
                Contact
              </p>


              <div className="footer-contact">

                <div className="contact-block">

                  <span className="contact-label">
                    CORPORATE OFFICE
                  </span>

                  <p>
                    Boch Investment Fund One<br />
                    4100 Woodward Ave, Suite 350<br />
                    Bloomfield Hills, MI 48304
                  </p>

                </div>


                <div className="contact-block">

                  <span className="contact-label">
                    INVESTOR RELATIONS
                  </span>

                  <a href="mailto:investor@bochbillboardinvestment.com">
                    investor@bochbillboardinvestment.com
                  </a>

                  <a href="tel:+19476222711">
                    +1 (947) 622-2711
                  </a>

                </div>

              </div>

            </div>

          </div>

        </div>


        {/* DIVIDER */}

        <div className="footer-divider"></div>


        {/* REGULATION DISCLAIMER */}

        <div className="footer-copy">

          <div className="footer-copy-label">

            <span></span>

            Regulation D 506(c) Mandated Legend

          </div>


          <p>

            Any historical performance data represents past performance. Past
            performance does not guarantee future results; Current performance
            may be different than the performance data presented; The Company
            is not required by law to follow any standard methodology when
            calculating and representing performance data; The performance of
            the Company may not be directly comparable to the performance of
            other private or registered funds or companies; The securities are
            being offered in reliance on an exemption from the registration
            requirements, and therefore are not required to comply with certain
            specific disclosure requirements; The Securities and Exchange
            Commission has not passed upon the merits of or approved the
            securities, the terms of the offering, or the accuracy of the
            materials.

          </p>

        </div>


        {/* BOTTOM BAR */}

        {/* <div className="footer-bottom">

          <span>
            © {new Date().getFullYear()} Nexora Systems
          </span>

          <span className="footer-bottom-right">
            Private Offering • Regulation D 506(c)
          </span>

        </div> */}


      </div>

    </footer>

  );
}

export default Dfoot;